// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const videoViewsHistoryConfig = {
    title: 'chart.tiktok.video_views_history',
    tooltip: 'chart.tiktok.tooltip_video_views_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.tiktok.video_views_history_name',
        avg: 'chart.tiktok.video_views_history_avg'
    },
    id: 'video_views_history',
    color: {
        value: 'purple'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
